// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgz_a","AdSlotBranding__desktop":"bgz_b","AdSlotBranding__mobile":"bgz_c"};